import { useCallback } from 'react';
import { useWorkspace } from '~/contexts';
import { useClientFilters, useExpenseFilters, useMemberFilters, useProjectFilters } from '~/hooks';
import { QueryString } from '~/utils';

export default function useExpenseItemsReportURL({ params = {}, query = {} } = {}) {
  const { workspace } = useWorkspace();

  const clientFilters = useClientFilters();
  const projectFilters = useProjectFilters();
  const memberFilters = useMemberFilters();
  const expenseFilters = useExpenseFilters();

  const url = useCallback(
    (p = {}) =>
      `/app/${workspace.key}/reports/expense-items?${new QueryString(
        {
          start: params.period?.start ?? params.start ?? 'not_set',
          end: params.period?.end ?? params.end ?? 'not_set',
          currency: params.currency ?? undefined,
          ...clientFilters.mapClickThroughParams(params),
          ...projectFilters.mapClickThroughParams(params),
          ...memberFilters.mapClickThroughParams(params),
          ...expenseFilters.mapClickThroughParams(params),
          ...query,
          ...p,
        },
        { multi: true },
      ).toString()}`,
    [params, workspace.key, clientFilters, projectFilters, memberFilters, expenseFilters, query],
  );

  return url;
}
